import React, { useEffect, useState, useContext } from 'react'
import { CNav, CNavItem, CNavLink, CTabContent, CTabPane, CRow, CCard } from '@coreui/react'
import SearchTable from 'src/components/searchTable'
import UserSubscriptionReport from './userSubscriptionReport'
import TransactionReport from './transactionReport'
import { ANALYTICS_API, SUBSCRIPTION_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import { AppContext } from 'src/views/context/app'
import getSymbolFromCurrency from 'currency-symbol-map'

const Analytics = () => {
  const { setLoader } = useContext(AppContext)
  const [activePane, setActivePane] = useState(1)
  const [totalData, setTotalData] = useState({
    totalSubscribers: 0,
    activeSubscribers: 0,
    revenue: 0,
  })

  const [{ data: subscriptionData, loading: subscriptionDataLoading }, subscriptionCall] = useAxios(
    {
      url: `${ANALYTICS_API}/subscription-analytics`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: subscriptionPlans, loading: subscriptionPlansLoading }, subscriptionPlansCall] =
    useAxios(
      {
        url: SUBSCRIPTION_API,
        method: 'get',
      },
      { manual: true },
    )
  useEffect(() => {
    subscriptionCall()
    subscriptionPlansCall()
  }, [])
  useEffect(() => {
    if (subscriptionData && subscriptionData.success) {
      let tempTotalsub = 0
      let tempActivesub = 0
      let tempRev = 0
      subscriptionData.data.forEach((element) => {
        tempTotalsub += element.total_subscribers
        tempActivesub += element.active_subscribers
        tempRev += element.revenue
      })
      setTotalData({
        totalSubscribers: tempTotalsub,
        activeSubscribers: tempActivesub,
        revenue: tempRev,
      })
    }
  }, [subscriptionData])

  useEffect(() => {
    setLoader(subscriptionDataLoading || subscriptionPlansLoading)
  }, [subscriptionDataLoading, subscriptionPlansLoading])

  const tableConfig = [
    {
      header: 'Plan Name',
      dataCell: (info) => info.name,
      width: 21,
    },
    {
      header: 'Plan ID',
      dataCell: (info) => info.id,
      width: 22,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In-Active'),
      width: 8,
    },
    {
      header: 'Price',
      dataCell: (info) =>
        `${Number(info.amount).toFixed(2)}${
          info.currency ? getSymbolFromCurrency(info.currency) : ''
        }`,
      width: 9,
    },
    {
      header: 'Total Subscribers',
      dataCell: (info) => info.total_subscribers,
      width: 15,
    },
    {
      header: 'Active Subscriptions',
      dataCell: (info) => info.active_subscribers,
      width: 15,
    },
    {
      header: 'Revenue',
      dataCell: (info) =>
        `${Number(info.revenue).toFixed(2)}${
          info.currency ? getSymbolFromCurrency(info.currency) : ''
        }`,
      width: 10,
    },
  ]

  const activeTab = { color: '#1976d2', fontSize: '1.1rem', cursor: 'pointer' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem', cursor: 'pointer' }
  return (
    <div className="">
      <h2>Subscription Analytics</h2>
      <CRow className="mt-3">
        <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 1 ? activeTab : inActiveTab}
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              {`Subscription / PPV`}
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 2 ? activeTab : inActiveTab}
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              User Subscription Report
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 3 ? activeTab : inActiveTab}
              active={activePane === 3}
              onClick={() => setActivePane(3)}
            >
              Transaction Report
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane role="tabpanel" visible={activePane === 1}>
            <CRow>
              <CCard>
                <SearchTable
                  type={`Subscription Analytics`}
                  tableCardHeight={65}
                  disableButton={true}
                  disableSearch={true}
                  marginDisable={true}
                  textAlign={'center'}
                  tableContent={subscriptionData?.data}
                  tableConfig={tableConfig}
                />
                <div className=" d-flex justify-content-end">
                  <div className="d-flex text-center align-items-center w-50 px-2">
                    <div className="font-weight-bold" style={{ width: '20%', fontWeight: 'bold' }}>
                      Total
                    </div>
                    <div className="border" style={{ width: '30%' }}>
                      {totalData.totalSubscribers}
                    </div>
                    <div className="border" style={{ width: '30%' }}>
                      {totalData.activeSubscribers}
                    </div>
                    <div className="border" style={{ width: '20%' }}>
                      {Number(totalData.revenue).toFixed(2)}
                    </div>
                  </div>
                </div>
              </CCard>
            </CRow>
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 2}>
            <CRow>
              <UserSubscriptionReport subscriptionData={subscriptionPlans?.data} />
            </CRow>
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 3}>
            <CRow>
              <TransactionReport subscriptionData={subscriptionPlans?.data} />
            </CRow>
          </CTabPane>
        </CTabContent>
      </CRow>
    </div>
  )
}

export default Analytics
